module.exports = __webpack_public_path__ + "static/media/img-cover.6aa7f7b6.svg";